import { render, staticRenderFns } from "./updateTextDialog.vue?vue&type=template&id=45c3be68"
import script from "./updateTextDialog.vue?vue&type=script&lang=js"
export * from "./updateTextDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports